import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});

const regulation = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [  {
        name: 'Significantly more difficult',
        data: [31, 25 ,8]
    },{
        name: 'Somewhat more difficult',
        data: [31, 22, 12]
    },{
        name: 'No impact',
        data: [0, 22, 8]
    },{
        name: 'Somewhat easier',
        data: [13, 22, 56]
    },{
        name: 'Significantly easier',
        data: [25, 9, 16]
    }]
}



const challenging2 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Others',
        data: [11, 17, 24]
    },{
        name: 'Employment',
        data: [20, 21, 15]
    },{
        name: 'Incorporation/Company ownership',
        data: [13, 21, 9]
    },{
        name: 'Tax',
        data: [20, 16, 15]
    },{
        name: 'Data protection and privacy',
        data: [15, 8, 9]
    },{
        name: 'Licensing',
        data: [15, 7, 17]
    },{
        name: 'IP Protection',
        data: [8, 10, 11]
    }]
}



export class ChapterEightyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>
        <TextHolder text="Overall, survey respondents disagreed on whether government regulations impede startup development. Most investors said regulation made it easier to start and scale technology businesses in their country. Community builders, on the other hand, felt regulation had made it harder." />
        <TextHolder text="" />

        <Highchartscomponent   chartsText="How has regulation in your country impacted the ability to start and scale technology businesses?" options={regulation} chartsBottomText="It also wasn’t clear which regulatory areas were most challenging for startups. Was it intellectual property protection, employment rules or tax issues? Responses were fairly evenly split for all of six areas our survey asked about. This is another issue for deeper investigation for the next edition of the report. " source="Source: 2018 State of SE Asian Tech Survey" />

        <Highchartscomponent   chartsText="Which area(s) of regulation are most challenging for your company?" options={challenging2} source="Source: 2018 State of SE Asian Tech Survey"  />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/82.js